import React from 'react';
import { useSelectedSlide } from '@components/Presentation/hooks/useSelectedSlide';
import Switch from '@molecules/Switch';
import { QuestionIcon } from '@phosphor-icons/react';
import Tooltip from '@components/Presentation/atoms/Tooltip';

function ShowCommentsOverlay() {
  const selectedSlide = useSelectedSlide();
  return (
    <div className="flex">
      <div className="flex flex-1 text-sm flex-nowrap">
        Show comments overlay &nbsp;
        <Tooltip content="Show audience responses as a callout in the lower right corner of the presentation.">
          <QuestionIcon size={20}

            className='!text-default-400'
          />
        </Tooltip>
      </div>
      <Switch
        checked={!!selectedSlide.setting.CommentsOverlay}
        onChange={(e) =>
          selectedSlide.handler.updateSetting(
            'CommentsOverlay',
            e.target.checked
          )
        }
        onClick={() => {}}
      />
    </div>
  );
}

export default ShowCommentsOverlay;
